import { forwardRef, useEffect, useState } from 'react';
import {
  Slide,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Container,
} from '@mui/material';
// components
import Iconify from '../../components/Iconify';
import {
  FoldableCrewProfileCard,
} from './';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function ProfilePreviewDialog({ isOpen, closeDialog, application }) {
  return (
    <Dialog open={isOpen} onClose={closeDialog} fullScreen TransitionComponent={Transition}>
      <AppBar position="relative" color="transparent" sx={{ boxShadow: 'none' }}>
        <Toolbar sx={{ px: 0 }}>
          <Box variant="h6" sx={{ flex: 1 }} />
          <IconButton color="inherit" edge="end" onClick={closeDialog} sx={{ mt: 2, mr: 2 }}>
            <Iconify icon="eva:close-fill" />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg">
        <Typography variant="h4" sx={{ mb: 3 }}>
          프로필은 기업에 이렇게 전달돼요
        </Typography>
        <FoldableCrewProfileCard
          candidate={application}
        />
      </Container>
    </Dialog>
  )
}